import { render } from "./Challenges.vue?vue&type=template&id=73dbb766&ts=true"
import script from "./Challenges.vue?vue&type=script&lang=ts"
export * from "./Challenges.vue?vue&type=script&lang=ts"

import "./Challenges.vue?vue&type=style&index=0&id=73dbb766&lang=postcss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__